import { useState } from "react";
import { useNavigate } from "react-router-dom";

import ReportingProductList from "./ReportingProductList";
// import ReportingProductPurchase from "./ReportingProductPurchase";

const period = [
  {
    value: 0,
    name: "Semua Period",
  },
  {
    value: 1,
    name: "Hari ini",
  },
  {
    value: 2,
    name: "Kemarin",
  },
  {
    value: 3,
    name: "Minggu Berjalan",
  },
  {
    value: 4,
    name: "Minggu Lalu",
  },
  {
    value: 5,
    name: "Bulan Berjalan",
  },
  {
    value: 6,
    name: "Bulan Lalu",
  },
  {
    value: 7,
    name: "Tahun Berjalan",
  },
  {
    value: 8,
    name: "Tahun Lalu",
  },
  {
    value: -2,
    name: "Pilih Tanggal",
  },
];

const FETCH_LIMIT = 25;

const ReportingProduct = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);

  return (
    <div className="text-[12px]">
      <div className="w-full justify-between border-2 mt-14 lg:mt-3 text-center grid grid-cols-2 divide-x">
        <button
          className={page === 1 ? "py-2 bg-blue-500 text-white" : "py-2"}
          onClick={() => setPage(1)}
        >
          Penjualan Produk
        </button>
        <button
          className={page === 2 ? "py-2 bg-blue-500 text-white" : "py-2"}
          onClick={() => setPage(2)}
        >
          Pembelian Produk
        </button>
      </div>
      <div>
        {page === 1 ? (
          <ReportingProductList
            period={period}
            FETCH_LIMIT={FETCH_LIMIT}
            isSell={true}
          />
        ) : (
          <ReportingProductList
            period={period}
            FETCH_LIMIT={FETCH_LIMIT}
            isSell={false}
          />
        )}
      </div>
    </div>
  );
};

export default ReportingProduct;
